import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import * as Bixby from '$/core';
import History from './History';

declare const gtag: (...params: any[]) => void;
let appInsights: any;
if (Bixby && Bixby.Configuration) {
  appInsights = Bixby.Utils.parseBoolean(Bixby.Configuration.disableAnalytics)
    ? undefined
    : new ApplicationInsights({
        config: {
          instrumentationKey: import.meta.env.VITE_APPLICATION_INSIGHTS_KEY,
          disableFetchTracking: false,
          enableCorsCorrelation: true,
        },
      });

  if (appInsights) {
    appInsights.loadAppInsights();
    const trackPageView = () =>
      setTimeout(() => {
        AnalyticsService.gtagEvent('event', 'page_view');
        appInsights.trackPageView({});
      }, 100);

    appInsights.context.application.build = Bixby.Configuration.version;
    History.listen(({ action }) => {
      if (action !== 'PUSH' && action !== 'REPLACE') {
        return;
      }

      // slight timeout to let the navigation happen first
      trackPageView();
    });

    // Log the current page view
    trackPageView();
  }
}

export default abstract class AnalyticsService {
  public static login(username: string) {
    AnalyticsService.gtagEvent('event', 'login');
    if (appInsights) {
      appInsights.setAuthenticatedUserContext(username);
    }
  }

  public static logout() {
    if (appInsights) {
      appInsights.clearAuthenticatedUserContext();
    }
  }
  public static event(name: string, props?: any) {
    AnalyticsService.gtagEvent('event', name, props);
    if (appInsights) {
      appInsights.trackEvent({ name }, props);
    }
  }
  public static exception(error: Error, props?: { [key: string]: any }) {
    if (appInsights) {
      const exceptionTelemetry: IExceptionTelemetry = {
        error,
      };

      if (props) {
        exceptionTelemetry.properties = props;
      }
      appInsights.trackException(exceptionTelemetry);
    }
  }

  public static gtagEvent(type: string, name: string, props?: any) {
    // window.dataLayer gets added if the gtag script is enabled on index.html
    if ((window as any).dataLayer) {
      gtag(type, name, props);
    }
  }
}
